import { render, staticRenderFns } from "./Direction.vue?vue&type=template&id=2cd0f735&scoped=true"
import script from "./Direction.vue?vue&type=script&lang=js"
export * from "./Direction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd0f735",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd0f735')) {
      api.createRecord('2cd0f735', component.options)
    } else {
      api.reload('2cd0f735', component.options)
    }
    module.hot.accept("./Direction.vue?vue&type=template&id=2cd0f735&scoped=true", function () {
      api.rerender('2cd0f735', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Direction.vue"
export default component.exports